import axios from 'axios';
import {
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCardText,
    MDBCol,
    MDBRow,
    MDBSwitch,
    MDBTabs,
    MDBTabsItem,
    MDBTabsLink,
    MDBCardHeader,
    MDBBtnGroup
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import PhoneFormModal from './PhoneFormModal';
import { UserProfileContext } from '../context/UserProfileProvider';

const PhoneCard = ({ phone, setPhones, setActiveTab, activeTab, setShowPhoneModal, setPhoneToUpdate, isCheckout, isDelete }) => {
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;

    const handleDelete = () => {
        axios({
            method: 'delete',
            url: `${baseUrl}/phones/${phone.id}`,
            data: Array.from([phone.id])
        })
            .then(response => {
                if (response.status === 200) {
                    setPhones(prevPhones => {
                        const updatedPhones = prevPhones.filter(ph => ph.id !== phone.id);
                        if (updatedPhones.length > 0) {
                            if (activeTab === phone.type) setActiveTab(updatedPhones[0].type);
                        } else {
                            setPhones([]);
                            setPhoneToUpdate(null);
                        }
                        return updatedPhones;
                    });
                }
            })
            .catch(err => console.error(err));
    };

    const handleUpdate = useCallback(() => {
        setShowPhoneModal(true);
        let phoneCopy = { ...phone };  // Make a copy of phone
        phoneCopy.number = phoneCopy.number.replace('+1 ', ''); // Remove "+1 " from phone number
        setPhoneToUpdate(phoneCopy);
    }, [setShowPhoneModal, setPhoneToUpdate, phone]);

    return (
        <MDBCard>
            <MDBCardBody>
                <MDBCardText>{phone.number}</MDBCardText>
            </MDBCardBody>
            <MDBBtnGroup className='mb-2 mx-2'> 
                    <MDBBtn color='primary' className='me-2 mt-2' onClick={handleUpdate}>Update</MDBBtn>
                    {isDelete && <MDBBtn color='danger' className='me-2 mt-2' onClick={handleDelete}>Delete</MDBBtn>}
                    <MDBBtn className='mt-2' onClick={() => setShowPhoneModal(true)} color='warning'>ADD New Phone</MDBBtn>
                    </MDBBtnGroup>
                {isCheckout && <MDBCol md="2">
                    <MDBSwitch md-5 id='billing' label='Select' />
                    </MDBCol>
            }
           
        </MDBCard>
    );
};

PhoneCard.propTypes = {
    isCheckout: PropTypes.bool,
    phone: PropTypes.array,
    setPhones: PropTypes.func,
    setActiveTab: PropTypes.func,
    activeTab: PropTypes.string,
    setShowPhoneModal: PropTypes.func,
    setPhoneToUpdate: PropTypes.func,
    isDelete: PropTypes.bool,
}

function PhoneView({ isCheckout }) {
    const { phones, setPhones } = useContext(UserProfileContext);
    const [activeTab, setActiveTab] = useState(phones.length > 0 ? phones[0].type : '');
    const [phoneToUpdate, setPhoneToUpdate] = useState(null);
    const [showPhoneModal, setShowPhoneModal] = useState(false);

    useEffect(() => {
        if (phones.length > 0) {
            setActiveTab(phones[0].type);
        }
    }, [phones]);

    const handleTabChange = (type) => {
        setActiveTab(type);
    }

    return (
        <MDBCol>
          <h5 className="display-8 fw-bold text-uppercase text-black mb-0 text-center" style={{ letterSpacing: '15px' }}>Phone</h5>
          <hr className="hr" />
    
          {phones.length > 0 ? (
            <>
              <MDBCardHeader className="text-center rounded" background="light">
                <MDBTabs className='card-header-tabs'>
                  {[...new Set(phones.map(phone => phone.type))].map((type) => (
                    <MDBTabsItem key={type}>
                      <MDBTabsLink active={activeTab === type} onClick={() => setActiveTab(type)}>
                        {type}
                      </MDBTabsLink>
                    </MDBTabsItem>
                  ))}
                </MDBTabs>
              </MDBCardHeader>
    


    
              <MDBRow className='justify-content-center'>
                {phones.filter(phone => activeTab === phone.type).map((phone) => (
                 <MDBCol  className='mb-4'  key={phone.id}>
                    <PhoneCard phone={phone} isCheckout={isCheckout} />
                  </MDBCol>
                ))}
              </MDBRow>
            </>
          ) : (
            <MDBBtn color='warning' onClick={() => setShowPhoneModal(true)}>ADD New Phone</MDBBtn>
          )}
    
          {showPhoneModal && <PhoneFormModal />}
        </MDBCol>
      );
}

PhoneView.propTypes = {
    isCheckout: PropTypes.bool,
}

export default PhoneView;
